import {
  IUiConfigButtonActionBody,
  IUiConfigButtonClientSideInput
} from "./types";

// Helper function to process body and replace clientSideInput placeholders
export const processBody = (
  body: IUiConfigButtonActionBody,
  clientSideInput: IUiConfigButtonClientSideInput
): IUiConfigButtonActionBody => {
  if (!body || typeof body !== "object") {
    return body;
  }

  const processedBody = JSON.parse(
    JSON.stringify(body)
  ) as IUiConfigButtonActionBody;

  const processValue = (value: unknown): unknown => {
    if (typeof value === "string") {
      const placeholderRegex = /\$\{clientSideInput\.(\w+)\}/g;
      return value.replace(placeholderRegex, (match, key) => {
        const replacement =
          clientSideInput[key as keyof IUiConfigButtonClientSideInput];

        return typeof replacement === "string" ? replacement : match;
      });
    } else if (typeof value === "object" && value !== null) {
      if (Array.isArray(value)) {
        return value.map((v) => processValue(v));
      }

      const entries = Object.entries(value).map(
        ([k, v]) => [k, processValue(v)] as const
      );
      return Object.fromEntries(entries) as Record<string, unknown>;
    }

    return value;
  };

  return processValue(processedBody) as IUiConfigButtonActionBody;
};
